import axiosInstance from '../axiosInterceptor/axiosInstance'

const getCompetitions = async (orgId) => {
  const url = `v1/orgs/${orgId}/competitions`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getCompetitions
